import React from 'react';
import { PageLayout } from '../../shared/PageLayout';
import { Seo } from '../../shared/Seo';
import { HeroSection, type HeroSectionProps } from '../../shared/HeroSection';
import { ServiceListSection } from '../../shared/ServiceListSection';
import { FeatureGridSection } from '../../shared/FeatureGridSection';
import { ModelsWeService } from '../../shared/ModelsWeService';
import { TestimonialGrid } from '../../shared/TestimonialGrid';
import { FaqAccordion } from '../../shared/FaqAccordion';
import { CallToActionSection } from '../../shared/CallToActionSection';

interface ServicePageLayoutProps {
  seo: {
    title: string;
    description: string;
    keywords: string;
    structuredData: object | object[];
  };
  hero: HeroSectionProps;
  serviceList: {
    introParagraph: string;
    services: any[];
  };
  features: {
    title?: string;
    subtitle?: string;
    badgeText?: string;
    items: any[];
    theme?: 'default' | 'alternative';
  };
  models: {
    title?: string;
    subtitle?: string;
    categories: any[];
  };
  testimonials: {
    items: any[];
  };
  faq: {
    items: any[];
  };
  cta: {
    title: string;
    subtitle: string;
    themeColor?: 'red' | 'blue' | 'purple' | 'yellow';
  };
}

export const ServicePageLayout: React.FC<ServicePageLayoutProps> = ({
  seo,
  hero,
  serviceList,
  features,
  models,
  testimonials,
  faq,
  cta
}) => {
  return (
    <PageLayout>
      <Seo {...seo} />
      <h1 style={{ position: 'absolute', left: '-9999px' }}>{typeof hero.title === 'string' ? hero.title : seo.title}</h1>
      
      <HeroSection {...hero} />
      
      <ServiceListSection 
        introParagraph={serviceList.introParagraph} 
        services={serviceList.services} 
      />
      
      <FeatureGridSection
        title={features.title || `Why Choose Device Doctor`}
        subtitle={features.subtitle || "Experience the difference with our professional repair services."}
        badgeText={features.badgeText || "Why Choose Us"}
        features={features.items}
        theme={features.theme || 'default'}
      />
      
      <ModelsWeService
        title={models.title || "Models We Service"}
        subtitle={models.subtitle || "We provide expert repair services for all major models."}
        modelCategories={models.categories}
      />
      
      <TestimonialGrid testimonials={testimonials.items} />
      
      <FaqAccordion faqs={faq.items} />
      
      <CallToActionSection
        title={cta.title}
        subtitle={cta.subtitle}
        themeColor={cta.themeColor}
      />
    </PageLayout>
  );
};